import styled from 'styled-components';
import List from 'react-chatview';

export const Container = styled(List)`
  position: relative;
  height: calc(100vh - 61px);
`;
